module.exports = __webpack_public_path__ + "static/img/295_TO8_1696.694641b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/295_TO8_1696.jpg
// module id = b+uE
// module chunks = 0